import { v4 as uuidv4 } from "uuid";

import {
  defaultDiscoveryProtocol,
  defaultProtocolType,
  otherTimeout,
  scopeLevelOption,
} from "./const";

export const getSurveillanceAPIKeyAndParams = (auth, path) => {
  const definedPath = {
    sites: {
      org: "/orgs/sites.read",
      site: "/orgs/sites.read",
    },
    existedDevices: {
      org: "/orgs/existedDevices.read",
      site: "/orgs/sites/existedDevices.read",
    },
    inventoryDevices: {
      org: "/orgs/devices/inventory.read",
      site: "/orgs/sites/devices/inventory.read",
    },
    discovery: {
      org: "/orgs/devices/provision/surveillanceDiscovery.update",
      site: "/orgs/sites/devices/provision/surveillanceDiscovery.update",
    },
    stopDiscovery: {
      org: "/orgs/devices/provision/surveillanceStop.update",
      site: "/orgs/sites/devices/provision/surveillanceStop.update",
    },
    authenticate: {
      org: "/orgs/devices/provision/surveillanceAuthenticate.update",
      site: "/orgs/sites/devices/provision/surveillanceAuthenticate.update",
    },
    adopt: {
      org: "/orgs/devices/provision/surveillanceAdopt.update",
      site: "/orgs/sites/devices/provision/surveillanceAdopt.update",
    },
  };

  const { scopeLevel, realm, orgs, sites } = auth;
  const levelId = { realm: realm?.id, org: orgs?.id, site: sites?.id };
  const isStandAloneOrg = !levelId.org || Object.keys(orgs || {})?.length === 0;
  const apiKey = isStandAloneOrg ? definedPath[path][scopeLevel] : `/ents${definedPath[path][scopeLevel]}`;
  const placeholder = isStandAloneOrg ? { orgId: levelId.realm } : { entId: levelId.realm, orgId: levelId.org };

  if (scopeLevel === scopeLevelOption.site && levelId.site) {
    placeholder.siteId = levelId.site;
  }

  return { apiKey, placeholder };
};

export const makeSurveillanceDiscoveryPayload = ({ auth }) => {
  const socketId = uuidv4();
  const { apiKey, placeholder } = getSurveillanceAPIKeyAndParams(auth, "discovery");

  return {
    apiKey,
    socketId,
    placeholder,
    params: {
      action: "start",
      timeout: otherTimeout,
      batchData: [
        {
          discoveryProtocol: defaultDiscoveryProtocol,
        },
      ],
    },
  };
};

export const makeSurveillanceStopDiscoveryPayload = ({ auth }) => {
  const socketId = uuidv4();
  const { apiKey, placeholder } = getSurveillanceAPIKeyAndParams(auth, "stopDiscovery");

  return {
    apiKey,
    socketId,
    placeholder,
    params: {
      action: "stop",
      timeout: otherTimeout,
      batchData: [
        {
          discoveryProtocol: defaultDiscoveryProtocol,
        },
      ],
    },
  };
};

export const makeSurveillanceAuthenticateDevicesPayload = ({ auth, selectedDevices, username, password }) => {
  const socketId = uuidv4();
  const { apiKey, placeholder } = getSurveillanceAPIKeyAndParams(auth, "authenticate");

  return {
    apiKey,
    socketId,
    placeholder,
    params: {
      timeout: otherTimeout,
      data: selectedDevices.map((device) => ({
        protocolType: defaultProtocolType,
        ipVersion: device.ipVersion || 4,
        macAddress: device.deviceId,
        ipAddress: device.ipAddress,
        deviceAccount: {
          username,
          password,
        },
      })),
    },
  };
};

export const makeSurveillanceAdoptDevicesPayload = ({
  auth,
  selectedDevices,
  selectedSiteId,
  selectedProxyDevice,
  username,
  password,
}) => {
  const socketId = uuidv4();
  const { apiKey, placeholder } = getSurveillanceAPIKeyAndParams(auth, "adopt");

  return {
    apiKey,
    socketId,
    placeholder,
    params: {
      siteId: selectedSiteId === "inventory" ? null : selectedSiteId,
      proxyUuid: selectedProxyDevice?.proxyUuid || "",
      devices: selectedDevices.map((device) => ({
        modelName: device.modelName,
        hardwareVersion: device.hardwareRevision,
        deviceId: device.deviceId,
        productCategory: device.productCategory,
        version: device.hardwareRevision,
        protocolType: device.protocolType || defaultProtocolType,
        localIp: device.ipAddress || "",
        ...(!device.isAuthenticatedByDiscovery ? {
          deviceAccount: device.deviceAccount || {
            username: username || device.username || "",
            password: password || device.password || "",
          },
        } : {}),
      })),
    },
  };
};
